import { render, staticRenderFns } from "./Creation.vue?vue&type=template&id=10c717c0&scoped=true&"
import script from "./Creation.vue?vue&type=script&lang=ts&"
export * from "./Creation.vue?vue&type=script&lang=ts&"
import style0 from "./Creation.vue?vue&type=style&index=0&id=10c717c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c717c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VDialog,VSwitch})
